import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Link } from 'react-router-dom';
import { Menu, LogOut, ChevronDown, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

const Header = ({ onToggleSidebar, locatieNaam }) => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    // AuthContext.logout zet de `?logout=1` flag en doet window.location.href.
    // Geen extra navigate() nodig.
    await logout();
  };

  const getRolBadge = (rol) => {
    switch (rol) {
      case 'admin':
        return <Badge className="bg-tw-gold text-tw-blue font-medium">Admin</Badge>;
      case 'manager':
        return <Badge className="bg-tw-blue text-white">Manager</Badge>;
      case 'bedrijfsleider':
        return <Badge className="bg-tw-blue text-white">Bedrijfsleider</Badge>;
      default:
        return <Badge className="bg-gray-100 text-gray-800">Medewerker</Badge>;
    }
  };

  const getInitials = (name) => {
    if (!name) return 'TW';
    return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  };

  return (
    <>
      <header className="bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={onToggleSidebar}
            className="hover:bg-gray-100 text-tw-blue"
          >
            <Menu className="w-5 h-5" />
          </Button>
          {locatieNaam && (
            <div className="hidden md:block">
              <span className="text-sm text-gray-500">Geselecteerde locatie:</span>
              <span className="ml-2 font-medium text-tw-blue">{locatieNaam}</span>
            </div>
          )}
        </div>
        
        <div className="flex items-center gap-4">
          {user && (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" className="flex items-center gap-2 h-auto py-1.5 hover:bg-gray-100">
                  <div className="w-8 h-8 bg-tw-blue rounded-full flex items-center justify-center text-white font-medium text-sm">
                    {getInitials(user.naam)}
                  </div>
                  <div className="hidden md:block text-left">
                    <div className="text-sm font-medium text-tw-blue">{user.naam}</div>
                    <div className="text-xs text-gray-500">{user.email}</div>
                  </div>
                  <ChevronDown className="w-4 h-4 text-gray-400" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-56">
                <DropdownMenuLabel className="flex flex-col gap-1">
                  <span>{user.naam}</span>
                  {getRolBadge(user.rol)}
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem asChild data-testid="menu-mijn-email">
                  <Link to="/mijn-email" className="cursor-pointer">
                    <Mail className="w-4 h-4 mr-2" />
                    Mijn e-mailinstellingen
                  </Link>
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={handleLogout} className="text-red-600 focus:text-red-600">
                  <LogOut className="w-4 h-4 mr-2" />
                  Uitloggen
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
